__turbopack_context__.v({
  "button-contact": "registration-module-scss-module__4ZyYQq__button-contact",
  "button-container": "registration-module-scss-module__4ZyYQq__button-container",
  "button-modal": "registration-module-scss-module__4ZyYQq__button-modal",
  "button-modal-row": "registration-module-scss-module__4ZyYQq__button-modal-row",
  "content": "registration-module-scss-module__4ZyYQq__content",
  "content-centered": "registration-module-scss-module__4ZyYQq__content-centered",
  "content-success": "registration-module-scss-module__4ZyYQq__content-success",
  "edit": "registration-module-scss-module__4ZyYQq__edit",
  "edit-modal": "registration-module-scss-module__4ZyYQq__edit-modal",
  "edit-text": "registration-module-scss-module__4ZyYQq__edit-text",
  "fade-in-ux308gp": "registration-module-scss-module__4ZyYQq__fade-in-ux308gp",
  "icon": "registration-module-scss-module__4ZyYQq__icon",
  "icon-error": "registration-module-scss-module__4ZyYQq__icon-error",
  "icon-success": "registration-module-scss-module__4ZyYQq__icon-success",
  "linkToClientButton": "registration-module-scss-module__4ZyYQq__linkToClientButton",
  "linkingWithoutCodeContainer": "registration-module-scss-module__4ZyYQq__linkingWithoutCodeContainer",
  "loader": "registration-module-scss-module__4ZyYQq__loader",
  "modal": "registration-module-scss-module__4ZyYQq__modal",
  "row-content": "registration-module-scss-module__4ZyYQq__row-content",
  "separator": "registration-module-scss-module__4ZyYQq__separator",
  "title": "registration-module-scss-module__4ZyYQq__title",
  "title-row": "registration-module-scss-module__4ZyYQq__title-row",
  "title-success": "registration-module-scss-module__4ZyYQq__title-success",
});
